import React, { Component } from 'react'
import PageViewer from '../../PageViewer'
import GaugeWidget from '../../../components/widgets/GaugeWidget'
import HttpServices from '../../../utils/Http.services'
import importedIcons from '../../../components/inputs/icons'
import DateTimeInput from '../../../components/inputs/DateTimeInput'
import DateTime from './DateTime'
import ButtonAnimated from '../../../components/buttons/ButtonAnimated'
import { checkTranslation, imageAddress, translate } from '../../../utils/useful'
import StagesManager from '../../../components/StagesManager'
// import UpgradeAccount from '../UpgradeAccount'
import Responsive from '../../../components/Responsive'
import FixedView from '../../../components/FixedView'

export default class AccountSetting extends Component {
    state = {

        limit: 12,
        skip: 0,
        // pje: [
        //     { name: '1Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '6:30 am', img: "/images/p1.png", img2: "/images/p3.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p2.png", img2: "/images/p1.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '5:00 pm', img: "/images/p4.png", img2: "/images/p5.png" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '1:30 am', img: "/images/p7.png", img2: "/images/p6.png" },
        //     { name: 'Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p1.png", img2: "" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 am', img: "/images/p1.png", img2: "/images/p8.png" },

        // ],
        chartOptions: {
            responsive: true,
            aspectRatio: 2 / 1,

        },

        license: {},
        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
        },
        page: {
            name: 'Account Setting',
            page: [],
        },
        type: 'pro',
        expiryDate: 1710245332000,
        chartOptions: {
            responsive: true,
            aspectRatio: 2 / 1,

        },

        licensesData: {
            label: ['data'],
            datasets: [{
                data: [5],
                maxValue: 12,
                info: "Used",
                backgroundColor: 'rgb(88, 86, 214)'
            },],
            type: 'day',
            hidePercentage: true,
        },

        storageData: {
            label: ['test'],
            datasets: [{
                data: [],
                maxValue: 0,
                info: 'MB',
                backgroundColor: 'rgb(88, 86, 214)'

            },],
        },

        expiryDateData: {
            label: ['data'],
            datasets: [{
                data: [198],
                maxValue: 365,
                info: "Days",
                backgroundColor: 'rgb(88, 86, 214)'
            },],
            type: 'day',
            hidePercentage: true,
        },

        updateOption: [
            { name: 'Change account plan', icon: '/assets/icons/useful/rocket.png', function: 'upgradeAccount' },
            { name: 'Purchase license', icon: '/assets/icons/useful/group (4).png', function: 'upgradeAccount' },
            { name: 'Purchase storage', icon: '/assets/icons/useful/cloud (1).png', function: 'upgradeAccount' },

        ]

    }


    componentDidMount() {

        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }
    init() {

        let data = { ...this.props.data }
        this.setState({ information: data })
        let body = { collection: data.collection }

        this.setState({ isLoading: true })
        // console.log('tpppp', this.props)
        let hub = this.props.applet.hub?._id ?? this.props.applet.hub
        HttpServices.request('getMyAccountInfo', { hub }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult.userInfo) {
                let storageData = this.state.storageData
                storageData.datasets[0].data[0] = fetchResult.userInfo.storage.used
                storageData.datasets[0].maxValue = fetchResult.userInfo.storage.total ?? 5000
                // console.log('storageData.datasets[0]', storageData)
                this.setState({ storageData }, () => {
                    // console.log('aaaaaaaaaaaaaaa', this.state.storageData)
                })
            }
            // console.log('this.state.license',fetchResult.license)
            this.setState({ license: fetchResult.license })
        })

    }
    upgradeAccount = () => {
        // console.log('this.props', this.props)
        this.props.changePage(['account', 'upgrade'])
    }
    render() {
        return (
            // <div>
            //     {/* <PageViewer page={this.state.page} applet={this.props.applet}/> */}

            // </div>
            <div className=" w-100 h-100  m-0 scroll-no-scrollbar pt-4 flexc flex-column px-3" style={{ backgroundColor: 'rgb(240, 240, 240)' }} >

                <div className='w-100 mb-4' style={{ maxWidth: 800 }}>
                    <div className=' py-3 br-8' style={{ backgroundColor: '#fff' }}>

                        <div className='pb-3  px-3' style={{ borderBottom: '1px solid #eee' }}>

                            <div className='flexcb flex-wrap'>
                                <div className='flexc'>
                                    <div className='flexcc mrd-3'>
                                        <img className='br-30' src={imageAddress(this.props.variables?.hub?.image, 'profile', 'thumb')} alt='' height={44} width={44} />
                                    </div>

                                    <div>
                                        <div className='flexc'>
                                            <p className='text-normal text-semibold'>{this.props.variables?.hub?.fullname}</p>

                                            <div className='br-20 flexc  text-smallest text-semibold mld-2' style={{ border: '1px solid rgb(0, 205, 116)', color: 'rgb(0, 205, 116)', padding: '2px 8px' }}>
                                                {/* <div className='br-10 mrd-1' style={{height:5,width:5,background: 'rgb(0, 205, 116)',}}></div> */}
                                                <p>{translate("Active")}</p>
                                            </div>
                                        </div>
                                        <p className='text-smaller text-semibold ' style={{ color: '#777' }}>@{this.props.variables?.hub?.username}</p>
                                    </div>
                                </div>

                                <div className='py-2 flexc'>

                                    <div ref={el => this.updateBut = el}>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => this.updateFixedView.showView()}
                                            title={translate('Update')}
                                            // icon='/assets/icons/plus-white.svg'
                                            textColor={this.props.colors?.textColor ?? '#fff'}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background ?? 'red'}


                                        />
                                    </div>


                                    <FixedView width={this.props.width} zIndex={10} ref={el => this.updateFixedView = el} nodeRef={this.updateBut} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={5} maxWidth={200} >
                                        <div className='bg-white br-10 p-1 shadow-3  ' >
                                            <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                                                {this.state.updateOption.map((section, index) => {
                                                    return (
                                                        <button key={index} onClick={() => this[section.function]()} className="flexcb w-100 px-2 py-2  hover-gray-no-filter br-5  transition-all "  >
                                                            <div className="flexc text-start">
                                                                <img className="transition-all" src={section.icon} width={22} alt='' />
                                                                <div className='mld-3'>
                                                                    <p className="font-size-12 main-c3 text-bold " style={{}}>{checkTranslation(section.name ?? section.title)}</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </FixedView>

                                </div>

                            </div>

                            <div className='br-10 mt-3  flexc flex-wrap' style={{ padding: 4, backgroundColor: 'rgb(251,240,207)' }}>
                                <div className='px-2 py-1 br-8 px-2 mrd-3 flexc' style={{ backgroundColor: '#fff' }}>
                                    <div className='br-8 p-1 mrd-2 flexcc' style={{ color: 'rgb(1,47,158)' }}>
                                        <img className='text-bold font-size-16' src='/assets/icons/applets/general/diamond-award.png' height={20} alt='' />
                                    </div>
                                    <div className='prd-4'>
                                        <p className='font-size-14 main-c2 weight-600 ' style={{ color: 'rgb(210,140,10)' }}>{this.state.license?.type ?? 'Starter'} account</p>
                                    </div>
                                </div>
                                <p className='font-size-13  text-semibold py-1 px-1' style={{ color: 'rgb(210,140,10)' }}>Your account will be expired on 2025/12/04 in 321 days</p>
                            </div>
                        </div>
                        <div className='d-flex px-3 pt-4 flex-wrap'>



                            <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '4', lg: '4', xl: '4' }}>

                                <div className=' mb-5'>
                                    <div className='d-flex flex-column align-items-center'>
                                        <p className="font-size-15 main-c2 weight-700 px-2 " >{translate("licenses")}</p>
                                        <div className=' flexcc flex-column mt-1'>

                                            <p className='text-smaller mb-3'>5 {translate("used")} / {this.state.license?.quantity} {translate("total")}</p>
                                            <div className='' style={{ maxWidth: 100 }}>
                                                <GaugeWidget
                                                    value={80}
                                                    data={this.state.licensesData}
                                                    // height={this.props.height}
                                                    options={this.state.chartOptions}
                                                    ref={el => this.chart = el}
                                                // backgroundColor={"#007aff"}
                                                />
                                            </div>

                                            <div className='mt-2 text-center'>
                                                <button className='text-link'>
                                                    <p>{translate("Purchase more license")}</p>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Responsive>


                            <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '4', lg: '4', xl: '4' }}>

                                <div className=' mb-5'>
                                    <div className='d-flex flex-column align-items-center'>
                                        <p className="font-size-15 main-c2 weight-700 px-2 " >{translate("Remaining days")}</p>
                                        <div className=' flexcc flex-column mt-1'>

                                            <p className='text-smaller mb-3'>5 used / 10 total</p>
                                            <div className='' style={{ maxWidth: 100 }}>
                                                <GaugeWidget
                                                    value={80}
                                                    data={this.state.expiryDateData}
                                                    // height={this.props.height}
                                                    options={this.state.chartOptions}
                                                    ref={el => this.chart = el}
                                                />
                                            </div>
                                            {/* <div>{198}</div> */}
                                        </div>

                                        <div className='mt-2 text-center'>
                                            <p className='text-smaller'>{translate("Recurring")}: <span style={{ color: '#007aff' }}>{translate("Monthly")}</span></p>
                                            <p className='text-smaller'>{translate("Auto renewal")}: <span style={{ color: '#007aff' }}>{translate("Active")}</span></p>

                                        </div>




                                    </div>
                                </div>
                            </Responsive>


                            <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '4', lg: '4', xl: '4' }}>

                                <div className=' mb-5'>
                                    <div className='d-flex flex-column align-items-center'>
                                        <p className="font-size-15 main-c2 weight-700 px-2 " >{translate("Storage usage")}</p>
                                        <div className=' flexcc flex-column mt-1'>

                                            <p className='text-smaller mb-3'>39.82 MB {translate("used")} / 5GB {translate("total")}</p>
                                            <div className='' style={{ maxWidth: 100 }}>
                                                <GaugeWidget
                                                    value={80}
                                                    data={this.state.storageData}
                                                    // height={this.props.height}
                                                    options={this.state.chartOptions}
                                                    ref={el => this.chart = el}
                                                />
                                            </div>

                                            <div className='mt-2 text-center'>
                                                <button className='text-link'>
                                                    <p>{translate("Purchase more storage")}</p>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Responsive>

                            {/* <div className=' mb-4'>
                                <div className='h-100 d-flex flex-column align-items-center'>
                                    <p className="font-size-15 main-c2 weight-700 px-2 pb-1 pt-3" >Expiry Date</p>
                                    <div className='pt-2 h-100 flexcc flex-column'>

                                        <div className='py-2 flexcc'>
                                            <DateTime data={this.state.license?.expiry} />
                                        </div>
                                        <GaugeWidget
                                            value={80}
                                            data={this.state.expiryDateData}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />
                                    </div>
                                </div>
                            </div> */}


                            {/* <div className=' mb-4'>
                                <div className='h-100 d-flex flex-column align-items-center'>
                                    <p className="font-size-15 main-c2 weight-700 px-2 pb-1 pt-3" >Storage</p>
                                    <div className='pt-2 h-100 flexcc'>
                                        <GaugeWidget
                                            value={80}
                                            data={this.state.storageData}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>

                {/* <div className='col-12 col-md-6 mb-4'>
                    <div className='h-100 d-flex flex-column align-items-center'>
                        <p className="font-size-15 main-c2 weight-700 px-2 pb-1 pt-3" >Admins</p>
                        <div className='pt-2 h-100 flexcc'>
                            <p>{this.state.license?.quantity}</p>
                        </div>
                    </div>
                </div> */}


                {/* <ViewSwitcherWidget viewType={'table'} data={this.props.data} variables={this.props.variables} functionsHandler={this.props.functionsHandler} params={this.props.params} baseUrl={this.props.baseUrl} changeWindowLink={this.props.changeWindowLink} windowData={this.props.windowData} page={this.props.page} width={this.props.width} formPages={this.props.formPages} isMobile={this.props.isMobile} colors={colors} /> */}
                {/* <ViewSwitcher
                applet={this.state.frame?.applet}
                data={this.state.data}
                permissions={this.props.permissions}
                headers={this.state.frame?.fields}
                page={this.state.frame}
                params={this.props.params}
                actions={this.state.actions}
                width={this.props.width}
                functionsHandler={this.functionsHandler}
                submitForm={this.submitForm}
                changeValue={this.changeValue}
                view={view}
                isLoadingData={this.state.isLoadingData}
                type={this.props.viewType ?? this.props.view?.type}
            /> */}
                {/* <PageBuilderMain page={this.state.page} permissions={this.props.permissions} userView={this.props.userView} baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} params={this.state.params} initData={this.state.initData} type={this.state.type}  ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors ?? {}} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={false} /> */}


            </div >
        )
    }
}
